var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRelease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5V3.5H9.5L6.5 0.5ZM5.75 3.5V0.5H1.625C0.992188 0.5 0.5 1.01562 0.5 1.625V11.375C0.5 12.0078 0.992188 12.5 1.625 12.5H8.375C8.98438 12.5 9.5 12.0078 9.5 11.375V4.25H6.5C6.07812 4.25 5.75 3.92188 5.75 3.5ZM6.875 10.25H3.125C2.91406 10.25 2.75 10.0859 2.75 9.875C2.75 9.6875 2.91406 9.5 3.125 9.5H6.875C7.0625 9.5 7.25 9.6875 7.25 9.875C7.25 10.0859 7.0625 10.25 6.875 10.25ZM6.875 8.75H3.125C2.91406 8.75 2.75 8.58594 2.75 8.375C2.75 8.1875 2.91406 8 3.125 8H6.875C7.0625 8 7.25 8.1875 7.25 8.375C7.25 8.58594 7.0625 8.75 6.875 8.75ZM7.25 6.875C7.25 7.08594 7.0625 7.25 6.875 7.25H3.125C2.91406 7.25 2.75 7.08594 2.75 6.875C2.75 6.6875 2.91406 6.5 3.125 6.5H6.875C7.0625 6.5 7.25 6.6875 7.25 6.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelease);
export default __webpack_public_path__ + "static/media/release.3f9ebd887ff2c862d95479bc3e8d6470.svg";
export { ForwardRef as ReactComponent };